export default {"src":"/_next/static/media/twitter.7a9b5077.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};